module.exports = __webpack_public_path__ + "img/sale-rank1.66e0f9d8.png";